<script>
import Vue from 'vue';
import ListGroup from './list_group';
import ListGroupItem from './list_group_item';
import { CheckboxGroup } from 'element-ui';

Vue.use(CheckboxGroup);

export default Vue.component('list-group-select', {
    components: {
        ListGroup,
        ListGroupItem
    },

    props: {
        value: {
            type: Array,
            default: () => []
        },

        trackBy: {
            type: String,
            default: 'id'
        },

        label: {
            type: String,
            default: 'label'
        },

        countKey: {
            type: String,
            default: undefined
        },

        options: {
            type: Array,
            required: true,
            default: () => []
        },

        canCheckAll: {
            type: Boolean,
            default: true
        },

        searchable: {
            type: Boolean,
            default: true
        },

        totalCount: {
            type: [String, Number],
            default: undefined
        },

        checkAllLabel: {
            type: String,
            default: 'Check All'
        },

        searchPlaceholder: {
            type: String,
            default: 'Find a filter'
        },

        emptyResults: {
            type: String,
            default: 'No results found'
        }
    },

    data() {
        return {
            search: '',
            checked: [],
        }
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.checked = value || [];
            }
        }
    },

    computed: {

        filteredOptions() {
            let formatSearch = this.search.toLowerCase();

            return this.options.filter(item => {
                let formatItem = item[this.label].toLowerCase();
                return formatItem.indexOf(formatSearch) >= 0;
            });
        },

        hasCountKey() {
            return typeof this.countKey !== 'undefined';
        },

        isIndeterminate() {
            let checkedCount = this.checked.length;
            return checkedCount > 0 && checkedCount < this.options.length;
        },

        checkAll() {
            let checkedCount = this.checked.length;
            let optionsCount = this.options.length;

            return checkedCount === optionsCount && optionsCount > 0 && checkedCount > 0;
        }
    },

    methods: {
        handleCheckAllChange(event) {
            if (event.target.checked) {
                this.checked = this.options.map(item => {
                    return item[this.trackBy];
                });
            } else {
                this.checked = [];
            }

            this.$emit('onChange', this.checked, this.filteredOptions);
        },

        onChange(value, item) {
            if (this.filteredOptions.length === 1) {
                if (value.target.checked) {
                    this.checked = [item];
                    this.$emit('onChange', this.checked, this.filteredOptions);
                } else {
                    this.checked = [];
                    this.$emit('onChange', [], this.filteredOptions);
                }
            } else {
                this.$emit('onChange', this.checked, this.filteredOptions);
            }
        },
    }
});
</script>

<template>
    <div>
        <list-group class="list-group--select">
            <list-group-item v-if="searchable && options.length">
                <div class="p-15">
                    <input type="text" class="form-control" :placeholder="searchPlaceholder" v-model="search">
                </div>
            </list-group-item>

            <list-group-item
                v-if="canCheckAll && options.length">

                <el-checkbox
                    :indeterminate="isIndeterminate"
                    :value="checkAll"
                    @change="handleCheckAllChange">

                    <span class="badge pull-right" v-if="totalCount">{{totalCount}}</span>
                    <span class="bold">{{checkAllLabel}}</span>
                </el-checkbox>
            </list-group-item>

            <template v-if="filteredOptions.length">
                <el-checkbox-group v-model="checked" class="list-group-item list-group--scroll">
                    <list-group-item v-for="item in filteredOptions" :key="item[trackBy]">
                        <el-checkbox
                            :label="item[trackBy]"
                            :key="item[trackBy]"
                            :disabled="item.disabled"
                            @change="onChange($event, item[trackBy])"
                        >
                            <span class="badge pull-right" v-if="hasCountKey">{{item[countKey]}}</span>
                            <span v-html="item[label]"></span>
                        </el-checkbox>
                    </list-group-item>
                </el-checkbox-group>
            </template>

            <template v-else>
                <list-group-item>
                    <div class="p-15 text-grey text-bold text-center">
                        {{emptyResults}}
                    </div>
                </list-group-item>
            </template>
        </list-group>
    </div>
</template>

